export function formatOutDate(tanggal) {
    // sudah format YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(tanggal)) {
        return tanggal;
    }

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(tanggal)) {
        const [d, m, y] = tanggal.split("/");
        return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }
    // fallback (kalau format aneh)
    return tanggal;
}
